import AdminConfig from './admin';

import ClientView from './PlanningModule';


export default {
  name : 'planning',

  type : 'module',
  
  label: 'agenda de planification',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-calendar-range',
  }
}